import * as React from "react";
import type { SVGProps } from "react";
const CardPanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M3.5 7.306c0-1.044.846-1.89 1.889-1.89H18.61c1.043 0 1.889.846 1.889 1.89v1.18h-17zm0 2.597h17v7.792a1.89 1.89 0 0 1-1.889 1.888H5.39A1.89 1.89 0 0 1 3.5 17.695zm1.889 7.791h3.778v-1.888H5.389z" clipRule="evenodd" /></svg>;
export default CardPanelIcon;